import $ from "jquery";
import { Keyword } from "../view/keyword";
import { KeywordRankingView } from "../view/keyword_ranking_view";

class KeywordRankingController {
  private form: any;
  private keywordRankingRoot: JQuery<HTMLElement>;
  private rankingTables: any[];
  private keyword: any;
  private view: any;

  constructor(
    form: any,
    rankingTables: any[],
    keywordRankingRoot: JQuery<HTMLElement>,
  ) {
    this.form = form;
    this.keywordRankingRoot = keywordRankingRoot;
    this.rankingTables = rankingTables;
    this.keyword = new Keyword($("#keyword"));
    this.view = new KeywordRankingView(
      this.rankingTables,
      this.keywordRankingRoot,
    );
  }

  initialize(): void {
    this.keyword.initialize();
    this.view.initialize();
  }

  render(): void {
    if (!this.form.supportedPartitions().includes(this.form.partition())) {
      this.view.showBadPartitionMessage(this.form.partition());
      return;
    }
    if (this.keyword.isNotFound()) {
      this.view.showKeywordNotFoundMessage(this.keyword.value());
      return;
    }
    const query = new RankingSetQuery(
      this.ajaxUrl(),
      this.form,
      this.rankingTypes(),
    );
    const urlParams = query.makeParams();
    query.execute().then(
      (rankings: any) => {
        this.view.insertRankings(rankings, urlParams);
      },
      (_res: any) => {
        this.view.renderErrorMessage("取得に失敗しました");
      },
    );
  }

  private rankingTypes(): string[] {
    return this.rankingTables.map((ranking) => ranking.type);
  }

  private ajaxUrl(): string {
    return this.keywordRankingRoot.data("ajax_url");
  }
}

class RankingSetQuery {
  private static readonly DEFAULT_ASPECT_ID = 0;
  private static readonly DEFAULT_MAX_RANK = 20;
  private static readonly DEFAULT_DIMENSION = "area";
  private static readonly DEFAULT_CATEGORY_ID = 0;
  private static readonly DEFAULT_AREA_ID = 0;

  private url: string;
  private form: any;
  private types: string[];

  constructor(url: string, form: any, types: string[]) {
    this.url = url;
    this.form = form;
    this.types = types;
  }

  execute(): JQuery.jqXHR {
    return $.ajax({
      url: this.url,
      data: this.makeParams(),
      dataType: "json",
    });
  }

  makeParams(): any {
    return {
      aspect: RankingSetQuery.DEFAULT_ASPECT_ID,
      max_rank: RankingSetQuery.DEFAULT_MAX_RANK,
      dimension: this.form.dimension() || RankingSetQuery.DEFAULT_DIMENSION,
      area: this.form.area() || RankingSetQuery.DEFAULT_AREA_ID,
      category: this.form.category() || RankingSetQuery.DEFAULT_CATEGORY_ID,
      types: this.types,
      partition: this.form.partition(),
      target: $("#target").val(),
      format: "json",
    };
  }
}

export { KeywordRankingController };
